'use client';
import { createIntl } from '@formatjs/intl';
import { use } from 'react';

function useGetIntl(params) {
    const { lang } = params;
    const messages = use(params.dictionaryPromise);
    const intl = createIntl({
        locale: lang,
        messages
    });
    return intl;
}

export { useGetIntl };
